// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as Util from "../../../common/util.bs.js";
import * as BsCss from "../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../../css/Theme.bs.js";
import * as React from "react";
import Link from "next/link";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";

var container = Curry._1(BsCss.style, {
      hd: BsCss.width(BsCss.pct(100.0)),
      tl: {
        hd: BsCss.display("flex"),
        tl: {
          hd: BsCss.flexDirection("row"),
          tl: {
            hd: BsCss.borderRadius(BsCss.px(10)),
            tl: {
              hd: BsCss.paddingTop(BsCss.rem(0.75)),
              tl: {
                hd: BsCss.paddingBottom(BsCss.rem(0.75)),
                tl: {
                  hd: BsCss.paddingLeft(BsCss.rem(1.25)),
                  tl: {
                    hd: BsCss.cursor("pointer"),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var highLighted = Curry._1(BsCss.style, {
      hd: BsCss.backgroundColor(Theme.Color.charcoal),
      tl: {
        hd: BsCss.color(Theme.Color.white),
        tl: /* [] */0
      }
    });

var leftIconContainer = Curry._1(BsCss.style, {
      hd: BsCss.width(BsCss.rem(2.0)),
      tl: /* [] */0
    });

var icon = Curry._1(BsCss.style, {
      hd: BsCss.marginTop(BsCss.px(5)),
      tl: {
        hd: BsCss.marginRight(BsCss.rem(1.25)),
        tl: /* [] */0
      }
    });

var tail = Curry._1(BsCss.style, {
      hd: BsCss.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BsCss.textAlign("right"),
        tl: /* [] */0
      }
    });

var Styles = {
  container: container,
  highLighted: highLighted,
  leftIconContainer: leftIconContainer,
  icon: icon,
  tail: tail
};

var make = React.memo(function (props) {
      var isHighlighted = props.isHighlighted;
      var title = props.title;
      var isHighlighted$1 = isHighlighted !== undefined ? isHighlighted : false;
      return JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx(Link, {
                        href: props.route,
                        prefetch: false,
                        children: JsxRuntime.jsxs("a", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                                            icon: props.icon,
                                            className: icon
                                          }),
                                      className: leftIconContainer
                                    }),
                                Util.ReactStuff.s(title),
                                isHighlighted$1 ? JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                                              icon: [
                                                "fas",
                                                "angle-right"
                                              ],
                                              className: icon
                                            }),
                                        className: tail
                                      }) : null
                              ],
                              "aria-label": title,
                              "aria-selected": isHighlighted$1,
                              className: Cn.make([
                                    container,
                                    isHighlighted$1 ? highLighted : ""
                                  ])
                            })
                      })
                });
    });

var Link$1;

export {
  Link$1 as Link,
  Styles ,
  make ,
}
/* container Not a pure module */
